import { useState, useRef, useEffect } from "react";
import { TbLogout } from "react-icons/tb";

export default function Header({ collapsed, userDetails = {}, logout }) {
  const { name = "", email = "", period = "" } = userDetails;

  const [openProfile, setOpenProfile] = useState(false);
  const profileRef = useRef(null);

  const getInitials = (fullName) => {
    if (!fullName) return "";
    return fullName
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };
  const getFirstName = (fullName) => {
    if (!fullName) return "";
    return fullName.trim().split(/\s+/)[0];
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header
      className={`fixed top-0 right-0 z-30 h-20 flex justify-between items-center px-8 border-b rounded-tl-2xl
      bg-gradient-to-r from-[#673AB7] to-[#1976D2] transition-all duration-300
      ${collapsed ? "left-20" : "left-64"}`}
    >

      <div>
        <h1 className="text-2xl font-medium text-white">
          {name ? `Good ${period}, ${getFirstName(name)}` : "Welcome"}
        </h1>
        <p className="text-xs text-white">{email}</p>
      </div>

      <div className="flex items-center gap-4">
        {/* <div className="w-12 h-12 rounded-full bg-[#FFFFFF]/20 flex items-center justify-center cursor-pointer">
          <button className="inline-block relative">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <span className="animate-ping absolute top-1 right-0.5 block h-1 w-1 rounded-full ring-2 ring-red-400 bg-red-600"></span>
          </button>
        </div> */}

        {/* Profile Avatar + Dropdown */}
        <div className="relative" ref={profileRef}>
          <div
            onClick={() => setOpenProfile((prev) => !prev)}
            className="w-12 h-12 rounded-full bg-[#FFFFFF]/20 text-xl font-semibold text-white flex items-center justify-center cursor-pointer"
          >
            {getInitials(name)}
          </div>

          {openProfile && (
            <div className="absolute right-0 mt-3 w-80 bg-white rounded-2xl shadow-lg border overflow-hidden z-50">
              {/* User Info */}
              <div className="flex items-center gap-3 px-4 py-5">
                <div className="w-12 h-12 shrink-0 rounded-full bggray textblack flex items-center justify-center font-semibold text-lg">
                  {getInitials(name)}
                </div>
                <div>
                  <p className="font-medium textblack">{name}</p>
                  <p className="text-sm textlight">{email}</p>
                </div>
              </div>
              <div className="border-t border-gray-100" />
              <button
                onClick={() => {
                  setOpenProfile(false);
                  logout();
                }}
                className="w-full flex items-center gap-4 px-8 py-7 transition hover:bg-gray-100"
              >
                <span className="textblack">
                  <TbLogout size={26} />
                </span>
                <p className="text-lg font-medium">Logout</p>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
